import { Inject } from '@odinjs/odin';
import { AutocompleteAPI, FieldAPI, FormAPI, InputAPI, PanelAPI } from '@philips-internal/oswald-ui-components';
import { Value } from '@philips-internal/oswald-ui-core';
import Controller, { OnBeforeCancel, OnBeforeSubmit, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import moment from 'moment';
import BaseController from '../../../../controllers/BaseController';
import { FragmentNames, ReverseTpnAliases } from '../../../../codegen';
import { ISO_FULL_DATE_FORMAT } from '../../../../constants/date-utils';
import { ReasonType } from '../adult-tpn/adult-tpn-types';
import ReverseLastEvent from '../reverse-last-event/reverse-last-event';

@Controller({ component: ReverseTpnAliases.REVERSE_TPN_LAYOUT, fragment: FragmentNames.REVERSE_TPN })
export default class ReverseTpnController extends BaseController {

  @Inject(ReverseTpnAliases.FORM_REASON)
  private formApi!: FormAPI;

  @Inject(ReverseTpnAliases.PANEL_LOADER)
  private feedbackPanelLoaderApi!: PanelAPI;

  @Inject(ReverseTpnAliases.AUTOCOMPLETE_REASON_LIST)
  private reasonAutocompleteApi!: AutocompleteAPI;

  @Inject(ReverseTpnAliases.NOTES_FIELD)
  private notesFieldApi!: FieldAPI;

  @Inject(ReverseTpnAliases.DATE_INPUT)
  private newDateInputApi!: InputAPI;

  @OnMount(ReverseTpnAliases.REVERSE_TPN_LAYOUT)
  handleMountLayout(): void {
    ReverseLastEvent.handleMountLayout(this);
  }

  @OnMount(ReverseTpnAliases.DATE_INPUT)
  handleDateFieldMount(event: MountEvent): void {
    const inputApi = event.target as InputAPI;
    const currentTimeMoment = moment();
    this.context.set({ currentTime: currentTimeMoment.format(ISO_FULL_DATE_FORMAT) });
    inputApi.setValue(currentTimeMoment.utc().format(ISO_FULL_DATE_FORMAT));
  }

  @OnMount(ReverseTpnAliases.FETCH_REASON)
  handleFetchReasonMount(event: MountEvent): void {
    ReverseLastEvent.fetchReasonMount(event, this);
  }

  @OnBeforeCancel(ReverseTpnAliases.FORM_REASON)
  handleCancelForm(): void {
    applicationContext.popNavigationItem();
  }

  @OnBeforeSubmit(ReverseTpnAliases.FORM_REASON)
  handleSubmitForm(): void {
    this.reverse();
  }

  private reverse(): void {
    this.feedbackPanelLoaderApi.setVisible(true);
    const reasonSelected = this.reasonAutocompleteApi.getValue() as unknown as ReasonType;
    const {
      encounterId,
      sequenceNumber,
      prescriptionNumber,
      solutionType
    } = this.historyService.getCurrentRouteParams();
    const dateHour = moment(this.newDateInputApi.getValue()).format(ISO_FULL_DATE_FORMAT)

    const body = {
      dateHour,
      encounterNumber: Number(encounterId),
      justificationDescription: this.notesFieldApi.getValue(),
      prescriptionNumber: Number(prescriptionNumber),
      reasonSequenceNumber: reasonSelected.sequenceNumber,
      situationSolutionType: Number(solutionType),
      solutionNumber: Number(sequenceNumber),
    } as Record<string, Value>;

    ReverseLastEvent.callEndPoint(this.formApi, body, this);
  }

}